"use client";

import { useEffect } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useQueryClient, useMutation, UseMutationOptions } from "@tanstack/react-query";

import { ApiResponse } from "src/types/common";

type ExtendedMutationOptions<TData, TError, TVariables, TContext> =
    UseMutationOptions<TData, TError, TVariables, TContext> & {
        queryKey?: string | readonly unknown[];
        showMessage?: boolean
    };

const useCustomMutation = <TData, TError extends AxiosError, TVariables = undefined, TContext = unknown>(
    options: ExtendedMutationOptions<TData, TError, TVariables, TContext>,
) => {
    const queryClient = useQueryClient();
    const { queryKey, showMessage = true, ...mutationOptions } = options;

    const mutation = useMutation<TData, TError, TVariables, TContext>(mutationOptions);

    useEffect(() => {
        if (mutation.isSuccess) {
            if (queryKey) {
                queryClient.invalidateQueries({ queryKey: [queryKey] });
            };
            messageHandler(mutation.data);
        };
    }, [mutation.status]);

    const messageHandler = (data: any) => {
        if (showMessage) {
            if (data?.succeed) {
                toast.success(data?.message || "با موفقیت انجام شد");
            } else {
                toast.error(data?.message || "خطا در انجام عملیات");
            };
        };
    };

    return { ...mutation };
};
export default useCustomMutation;